import { useEffect } from "react";

export const usePageTitle = (title) => {
  useEffect(() => {
    document.title = title
      ? `${title} - Hyrano`
      : "Hyrano - Social Casino Entertainment";
  }, [title]);
};